export default __webpack_public_path__ + "static/media/3.ecc685b8.jpg";